/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import types */
import type { DeviceSensorCsvMetadataGroup } from '@/types/deviceSensor';

const MUENSTER_BASE_SENSOR_TYPES_BY_GROUP: Record<DeviceSensorCsvMetadataGroup, readonly string[]> = {
    BL: ['P', 'W'],
    GAS: ['V'],
    GRID_FEED: ['P', 'W'],
    HE: ['P', 'W'],
    PV: ['P', 'W'],
    WATER: ['V'],
};

export function getMuensterBaseSensorTypes(
    groups: readonly DeviceSensorCsvMetadataGroup[],
): string[] {
    return Array.from(new Set(groups.flatMap((group) => MUENSTER_BASE_SENSOR_TYPES_BY_GROUP[group])));
}
